
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './assets/css/animate.css'
import './assets/css/utilities.css'
import './assets/css/style.css'
import './assets/css/admin.css'
import './assets/css/responsive.css'
import AppRoutes from './AppRoutes';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

function App() {
  const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
    return null;
  };
  return (
      <BrowserRouter>
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
  );
}

export default App;
